import { createFileRoute, redirect } from '@tanstack/react-router';

/** customers.md section 3: العملاء is the first item; the app root lands there. */
export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ to: '/customers' });
  },
});
